import { Box, Stack, Typography } from '@mui/material'
import { useContext } from 'react'
import { errorMsg } from '../constants/messages'
import { ReactComponent as CotopatImage } from '../images/cotopat-logo.svg'
import { LanguageContext } from '../util/LanguageContext'

// 匿名ログイン有効期限切れ画面
export const AnonymousLoginExpired = () => {
  // 文字列変換用
  const translation = useContext(LanguageContext)
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'auto',
        background: '#F2F2F2 0% 0% no-repeat padding-box',
      }}
    >
      <Stack direction="column">
        <Box mt="104px" display="flex" justifyContent="center">
          <CotopatImage width="156px" height="40px" />
        </Box>
        <Typography
          sx={{
            mt: '81px',
            top: '315px',
            left: '759px',
            font: 'normal normal normal 17px/25px Noto Sans JP',
            color: '#282828',
          }}
        >
          {translation[errorMsg.EXPIRES_ERROR]}
        </Typography>
      </Stack>
    </Box>
  )
}
